<template>
  <Modal id="feedback-added" modifier="testimonial" #default="{ close }">
    <div class="close" @click="close">
      <SvgIcon name="close" />
    </div>

    <h2>{{ $t('ModalFeedbackAdded.title') }}</h2>
    <p>{{ $t('ModalFeedbackAdded.text') }}</p>
  </Modal>
</template>

<script>
import Modal from '@/components/modals/Modal'
import { withUi } from '../ui'

export default {
  name: 'ModalFeedbackAdded',
  components: { Modal },
  mixins: [withUi],
}
</script>

<style lang="scss">
#modal-feedback-added {
  .close {
    position: absolute;
    z-index: 3;
    top: 20px;
    right: 10px;
    color: $dark;
    font-size: 0;
    padding: 10px;
    cursor: pointer;
    transition: color 0.25s $ease;
    .svg-icon {
      font-size: 14px;
    }
    &:hover {
      color: $primary;
    }
  }
  h2 {
    font-weight: bold;
    font-size: 24px;
    line-height: 29px;
    text-align: center;

    margin-top: 40px;
    margin-bottom: 26px;
    @media (max-width: 480px) {
      font-size: 20px;
      margin-top: 10px;
      margin-bottom: 8px;
      text-align: left;
    }
  }
  p {
    font-size: 14px;
    line-height: 1.6;
    text-align: center;
    margin-bottom: 80px;
    @media (max-width: 480px) {
      text-align: left;
      margin-bottom: 40px;
    }
  }
}
</style>
